import React from "react";

const About = () => {
  return (
    <div>
      <section
        className="page-title-section overlay"
        data-background="images/backgrounds/page-title.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <img
                className="img-fluid rounded-circle w-75 h-75 mx-auto d-block"
                src="images/slpLogo.jpg"
                alt="About"
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 text-center">
                <h1 className="text-lighten h1 lead font-weight-bold">
                  About Us
                </h1>
              <p className="text-lighten text-justify lead font-weight-bold">
                The speech clinic offers a range of services to help adults with speech and language disorders such as dysphagia, aphasia, stammeringand motor speech disorders.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section pt-0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <img
                className="img-fluid w-100 mb-4"
                src="images/file_0000000048b47208966317ba5f86e455.png"
                alt="About"
              />
              <h2 className="section-title text-center">ABOUT OUR JOURNEY</h2>
              <p className="text-justify lead font-weight-bold text-center ml-5 mr-5">
              I’m Jamshaid Haider Malik, a Speech-Language Pathologist (MS-SLP) with formal academic training and clinical experience focused on adult and neurological speech therapy.
I hold a BS in Speech-Language Pathology (Gold Medalist) and a Master’s degree in Speech-Language Pathology/Therapy, with postgraduate focus on speech and language sciences, dysphagia management, and advanced clinical practice.
My clinical experience includes work in hospital, outpatient, and rehabilitation settings, providing assessment and therapy for adults with:
<ul>
  <li>Post-stroke speech and language difficulties</li>
  <li>Motor speech disorders</li>
  <li>Voice disorders
  </li>Aphasia
  <li>Swallowing (dysphagia) issues</li>
</ul>
I also serve in academic and clinical supervisory roles, ensuring my practice remains ethical, evidence-based, and outcome-focused.
                </p>
                
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
